import React from "react";

export default function PremiumHybridCeramicCoat() {
  return (
    <div className="space-y-2 text-sm text-gray-800">
      <p className="font-semibold">Includes:</p>
      <ul className="list-disc text-black-500 ">
          <li>Hybrid Ceramic Coating</li>
          <li>Premium Natural Foam Car Shampoo</li>
          <li>High Pressure Foam Wash</li>
          <li>Interior Cleaning</li>
          <li>High Pressure Vacuum</li>
          <li>Showroom Quality Polish</li>
          
            <b>
              CLEANING INSIDE BONNET IS AT OWNER'S RISK. - NOT RECOMMENDED (RS
              100 EXTRA)
            </b>
          
        </ul>
    </div>
  );
}


